import { useFormikContext } from 'formik';
import { isEqual } from 'lodash';
import { useEffect } from 'react';

interface FormikValueListenerProps<T> {
  onValueChanged: (initialValue: T, changedValues: T) => void;
}
export const FormikValueListener = <T,>({ onValueChanged }: FormikValueListenerProps<T>) => {
  const { values, initialValues } = useFormikContext<T>();

  useEffect(() => {
    if (!isEqual(values, initialValues)) {
      onValueChanged(initialValues, values);
    }
  }, [values, initialValues, onValueChanged]);

  return null;
};

export default FormikValueListener;
